<template>
  <div>
    <v-btn color="primary" to="/tags/new">
      태그 등록
      <v-icon right>mdi-plus</v-icon>
    </v-btn>

    <v-data-table
      :items="items"
      :headers="headers"
      :server-items-length="count"
      :options="pagination"
      :loading="loading"
      @update:page="move"
      :footer-props="{
        'disable-items-per-page': true,
        'items-per-page-options': []
      }"
    >
      <template v-slot:item.edit="{ item }">
        <v-btn icon :to="getEditPath(item.id)"><v-icon>mdi-pencil</v-icon></v-btn>
        <v-btn icon @click="remove(item)"><v-icon>mdi-delete</v-icon></v-btn>
      </template>
    </v-data-table>

    <v-divider></v-divider>
  </div>
</template>

<script>
import { getTags, removeTag } from '@/api'
import { getPaginationParams } from '@/utils'

export default {
  data () {
    return {
      tags: [],
      count: 0,
      loading: false,
      headers: [
        {
          text: '태그명',
          value: 'value'
        },
        {
          text: '회사',
          value: 'company'
        },
        {
          text: '등록수',
          value: 'count'
        },
        {
          text: '편집',
          value: 'edit'
        }
      ],
      pagination: {
        page: 1,
        itemsPerPage: 30
      }
    }
  },
  computed: {
    items () {
      return this.tags.map(tag => {
        console.log(tag)
        return {
          ...tag,
          company: tag.company ? tag.company.name : null
        }
      })
    }
  },
  async beforeRouteEnter (to, from, next) {
    let page = parseInt(to.query.page, 10) || 1
    if (page < 1) page = 1

    const params = getPaginationParams(to)

    try {
      const { items, count } = await getTags(params)

      next(vm => {
        vm.tags = items
        vm.count = count
        vm.pagination.page = page
      })
    } catch (err) {
      console.error(err)
      next()
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      await this.fetch(to)
      next()
    } catch (err) {
      next()
    }
  },
  methods: {
    async fetch (route) {
      this.loading = true
      try {
        const params = getPaginationParams(route)

        const { items, count } = await getTags(params)

        this.tags = items
        this.count = count
      } finally {
        this.loading = false
      }
    },
    move (page) {
      if (page !== this.pagination.page) {
        this.pagination.page = page
        this.$route.push({ query: { page } })
      }
    },
    getEditPath (id) {
      return `/tags/${id}/edit`
    },
    async remove (item) {
      const id = item.id
      const value = item.value

      const message = `태그 ${value} 를 정말 삭제하시겠습니까?`

      if (!confirm(message)) return

      try {
        await removeTag(id)
        await this.fetch(this.$route)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
